<template>
    <div class="or-admin-product-card-title flex-row">
        <p class="title">{{title.slice(0,25)}}{{title !== title.slice(0,25) ? '...' : null}}</p>
        <p class="delete hover-pointer hover-red" @click="$emit('remove')">Удалить</p>
        <p v-if="!$parent.show_edit" class="edit hover-pointer hover-yellow" @click="$emit('show-edit')">Редактировать информацию</p>
        <p v-else class="edit hover-pointer hover-yellow" @click="$emit('hide-edit')">Свернуть информацию</p>
        <p class="edit hover-pointer hover-yellow" @click="$emit('selected')">Открыть конструктор страницы</p>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
    }
}
</script>

<style scoped>
    .or-admin-product-card-title {
        font-size: 14px;
        line-height: 16px;
    }
    .title {
        font-weight: bold;
        color: #000000;
    }
    .delete {
        font-weight: normal;
        color: #b5b5b5;
        margin-left: 15px;
    }
    .edit {
        font-weight: normal;
        color: #b5b5b5;
        margin-left: 15px;
    }
</style>